import styled, { css } from 'styled-components';

import breakpoint from 'styled-components-breakpoint';

const Section = styled.section<{ background: string }>`
  display: flex;
  flex-direction: column;
  min-height: 651px;
  max-width: 23.375rem;
  overflow: hidden;
  background-size: cover;
  background-position: 70% top;
  padding: 5.625rem 1rem 8.43rem;
  margin: auto;

  ${({ background }) =>
    background &&
    css`
      background-image: ${`url(${background})`};
    `}

  .gallery-title {
    font-size: 2.25rem;
    margin: 0 0 4rem;
    width: 100%;
  }

  ${breakpoint('sm', 'md')`
    padding-right: 1.5rem;
    padding-left: 1.5rem;
    max-width: 43.5rem;

    .gallery-title {
      width: 80%;
      font-size: 1.75rem;
    }
  `}

  ${breakpoint('md', 'lg')`
    padding-right: 2.5rem;
    padding-left: 2.5rem;
    max-width: 85rem;

    .gallery-title {
      width: 70%;
    }
  `}

  ${breakpoint('lg')`
    padding-right: 4rem;
    padding-left: 4rem;
    max-width: 77.375rem;

    .gallery-title {
      width: 70%;
    }
  `}
`;

const Grid = styled.div`
  display: grid;
  align-content: space-between;
  justify-content: space-between;
  grid-template-columns: repeat(1, 20.3125rem);
  gap: 2.5rem;

  .grid-item {
    box-sizing: border-box;
    width: 20.3125rem;
    height: 20.3125rem;
    perspective: 1000px;

    &:nth-child(2n) {
      .card {
        .card-front,
        .card-back {
          background-color: #2f3f56;
          color: #fff;

          h2 {
            color: #fff;
          }
        }
      }
    }
  }

  ${breakpoint('sm', 'md')`
    grid-template-columns: repeat(2, 18.75rem);

    .grid-item {
      width: 18.75rem;
      height: 18.75rem;

      &:last-child {
        display: none;
      }
    }
  `}

  ${breakpoint('md')`
    grid-template-columns: repeat(3, 18.75rem);

    .grid-item {
      width: 18.75rem;
      height: 18.75rem;

      &.grid-item:not(.item-image):hover {
        .card {
          transform: rotateY(-180deg);
        }
      }
    }
  `}

  ${breakpoint('lg')`
    grid-template-columns: repeat(3, 21.375rem);

    .grid-item {
      width: 21.375rem;
      height: 21.375rem;
    }
  `}
`;

const Card = styled.div`
  width: 100%;
  height: 100%;
  position: relative;

  h2 {
    margin: auto;
  }

  .card-front,
  .card-back {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    justify-content: center;
    align-items: flex-start;
    box-sizing: border-box;

    img {
      margin: 0;
      object-fit: cover;
    }

    p {
      margin: 0 auto auto;
      font-size: 1rem;
    }

    .item-cta {
      margin: auto auto 0 0;
    }
  }

  .card-back {
    h2 {
      font-size: 1.25rem;
    }
  }

  &.card:not(.card-image) {
    border: 5px solid #2f3f56;

    .card-front {
      display: none;
      padding: 3.125rem;
    }

    .card-back {
      padding: 1.875rem 3.125rem;

      h2 {
        font-size: 1.1525rem;
        margin: auto 0 0.875rem;
      }
    }
  }

  ${breakpoint('md')`
    .card-back {
      p {
        margin: auto;
        font-size: 1.125rem;
      }

      h2 {
        display: none;
      }
    }

    &.card:not(.card-image) {
      transition-duration: 0.8s;
      transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
      transform-style: preserve-3d;

    .card-front {
        display: flex;
        cursor: pointer;
        backface-visibility: hidden;
        transform: rotateX(0deg);
        z-index: 2;
      }

      .card-back {
        backface-visibility: hidden;
        transform: rotateY(-180deg);
      }
    }
  `}

  ${breakpoint('sm', 'md')`
    .card-back {
      p {
        font-size: 0.875rem;
      }

      h2 {
        font-size: 1.1525rem;
      }
    }
  `}
`;

export { Section, Grid, Card };
